import moderation from '@spotim/fed-resources/resources/moderation';
import { dispatch } from 'state/store';
import { updateSpot } from '../../../../../spots/spotsSlice';

function verifyCode(context, payload, done) {
  var { spotId, status, sendTwoWayVerificationEvent, successCb } = payload;
  moderation
    .twoWayVerification(spotId, status)
    .then(
      response => {
        if (!response.success && response.code) return;
        var data = response.body;
        data.spot = {
          id: spotId,
          isRequiredTwoStepVerification: status
        };
        try {
          dispatch(updateSpot({ id: spotId, isRequiredTwoStepVerification: status }));
          sendTwoWayVerificationEvent(status, true);
          if (status) {
            successCb();
          }
        } catch (reason) {
          twoWayVerificationFailed(context, reason);
          sendTwoWayVerificationEvent(status, false);
        }
      },
      reason => {
        twoWayVerificationFailed(context, reason);
        sendTwoWayVerificationEvent(status, false);
      }
    )
    .finally(done);
}

function twoWayVerificationFailed(context, reason) {
  try {
    console.error(reason);
  } catch (ex) {
    console.error(ex);
  }
}

export default verifyCode;
